import React from "react";
import { createContext, useState } from "react";

export const ThemeContext = createContext();

export const ThemeContextProvider = ({ children }) => {
  const [transportDriver, settransportDriver] = useState();
  const [globaldistance, setglobaldistance] = useState()
  const [globalduration, setglobalduration] = useState()

  return (
    <ThemeContext.Provider value={{ transportDriver, settransportDriver,globaldistance, setglobaldistance,globalduration,  setglobalduration}}>
      {children}
    </ThemeContext.Provider>
  );
};
